import { BsHouseDoor } from "react-icons/bs";
import { FaSwimmingPool } from "react-icons/fa";

const overviewFilters = [
  {
    label: "Populaire filters",
    name: "popularFilters",
    icon: () => <FaSwimmingPool />,
    color: "orange",
    options: [
      {
        value: "pool",
        countKey: "pool",
        label: "Zwembad",
        checked: false,
      },
      {
        value: "pets",
        countKey: "pets",
        label: "Huisdieren toegestaan",
        checked: false,
      },
      {
        value: "holiday-park",
        countKey: "park",
        label: "Op een vakantiepark",
        checked: true,
      },
      {
        value: "ski-area",
        countKey: "skiArea",
        label: "In een skigebied",
        checked: false,
      },
    ],
  },
  {
    label: "Type vakantiehuis",
    name: "houseType",
    icon: () => <BsHouseDoor />,
    color: "violet",
    options: [
      {
        value: "villa",
        countKey: "Villa",
        label: "Villa",
        checked: true,
      },
      {
        value: "chalet",
        countKey: "Chalet",
        label: "Chalet",
        checked: true,
      },
      {
        value: "farmhouse",
        countKey: "Farmhouse",
        label: "Boerderij",
        checked: false,
      },
      {
        value: "holiday-home",
        countKey: "Holiday home",
        label: "Vakantiehuis",
        checked: false,
      },
      {
        value: "bungalow",
        countKey: "Bungalow",
        label: "Bungalow",
        checked: false,
      },
      {
        value: "apartment",
        countKey: "Apartment",
        label: "Appartement",
        checked: false,
      },
      {
        value: "cottage",
        countKey: "Cottage",
        label: "Cottage / gîte",
        checked: false,
      },
      {
        value: "castle",
        countKey: "Castle",
        label: "Kasteel",
        checked: false,
      },
      {
        value: "mansion",
        countKey: "Mansion",
        label: "Herenhuis",
        checked: false,
      },
      {
        value: "tent-lodge",
        countKey: "Tent lodge",
        label: "Tent lodge",
        checked: false,
      },
      {
        value: "mobile-home",
        countKey: "Mobile Home",
        label: "Stacaravan",
        checked: false,
      },
      {
        value: "manor",
        countKey: "manor",
        label: "Landhuis",
        checked: false,
      },
      {
        value: "mill",
        countKey: "Mill",
        label: "Molen",
        checked: false,
      },
      {
        value: "house-boat",
        countKey: "House Boat",
        label: "Woonboot",
        checked: false,
      },
      {
        value: "boat",
        countKey: "Boat",
        label: "Boot",
        checked: false,
      },
      {
        value: "cave",
        countKey: "Cave house",
        label: "Grotwoning",
        checked: false,
      },
    ],
  },
];

export default overviewFilters;
